import React from 'react';
import Lottie from 'react-lottie';
import './Notes_Lottie.css';
import * as animationData from './Notes_Lottie.json';

function Notes_Lottie() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  return (
    <section className='main'>
      <div className='Notes_Lottie_icon'>
        <Lottie className="me-auto"
          options={defaultOptions}
        // height={60}
        // width={60}          
        />
      </div>
    </section>
  );
}
export default Notes_Lottie;